module.exports = __webpack_public_path__ + "media/flags/mg-4d7239d1.svg";